<template>
    <div
        v-spinner="loading"
        class="app-setting"
    >
        <v-spinner :opacity="0.5">
            加载中...
        </v-spinner>
        <template v-if="!loading">
            <v-page-header title="应用基础设置" />
            <v-page-header
                :title="isExpertWorkbench ? '专家视角-企微专家工作台' : '访客视角-企微员工服务咨询'"
                level="section"
            />
            <div class="app-setting-content">
                <div class="app-setting-content-left">
                    <Wechat
                        :message="showMessage"
                        :config="appDetail"
                        :is-expert-workbench="isExpertWorkbench"
                    />
                    <div
                        v-if="isExpertWorkbench"
                        class="app-setting-content-left-tip"
                    >
                        *示意图中专家侧收到的消息提示语仅为示意，真实场景下会根据来访员工实际情况来显示
                    </div>
                </div>
                <v-descriptions :col="2">
                    <v-description-item
                        :col="1"
                        text="应用名称/图标/描述"
                        :extendable="true"
                    >
                        <span>
                            请前往<a target="__blank" :href="weworkLoginUrl">企微后台</a>
                        </span>
                    </v-description-item>
                    <v-description-item
                        v-if="isExpertWorkbench"
                        :col="1"
                        text="消息的提示语"
                    >
                    <div class="message-setting-content">
                        <tag-editor
                            ref="tagEditor"
                            :tags="EDITOR_TAGS"
                            :value="message"
                            :limit="80"
                            @on-change="handleInputChange"
                        />
                        <div class="message-setting-content-tip">
                            此提示语仅适用于【企微咨询】接入；【网页咨询】接入的提示语显示为"你有一个网页用户进线，请点击<span
                                class="link"
                            >此处</span>进行接待"，不支持修改。
                        </div>
                    </div>
                    </v-description-item>
                    <div
                        v-else-if="appDetail.tmpl_type === 2"
                        class="app-setting-content-right-message-setting"
                    >
                        <div class="message-setting-tip">
                            访客咨询方式：网页咨询
                        </div>
                        <div class="message-setting-content">
                            <p class="description">
                                访客点击“网页咨询”按钮后浏览器打开网页咨询窗口。此时无法用企微输入框进行咨询。
                            </p>
                            <p class="description">
                                *如需修改咨询方式，请联系售后处理
                            </p>
                        </div>
                    </div>
                    <div
                        v-else-if="appDetail.tmpl_type === 1"
                        class="app-setting-content-right-message-setting"
                    >
                        <div class="message-setting-tip">
                            访客咨询方式：企微输入框咨询
                        </div>
                        <div class="message-setting-content">
                            <p class="description">
                                点击企微会话窗口右下角的按钮切换到输入态进行咨询
                            </p>
                            <p class="description">
                                *如需修改咨询方式，请联系售后处理
                            </p>
                        </div>
                    </div>
                </v-descriptions>
            </div>
            <v-footer-actionbar v-if="isExpertWorkbench" size="large" :layout="layout" class="app-setting-footer" @confirm="handleSave" @cancel="handleReset" />
        </template>
        <aside-nav :visible="visible" />
    </div>
</template>

<script>
import { getWeorkLoginPage } from 'src/cgi/getWeworkInfo';
import Wechat from './components/Wechat';
import { ERR_APP_ID_CODE, ERR_APP_ID_CODE_JUMP_URL } from '../const';
import { envDomain } from '@/utils/domainConfig';
import { getAppId } from '../utils/helper';
import TagEditor from './components/TagEditor';
import AsideNav from '@/components/aside-nav';

const EDITOR_TAGS = ['[组织架构]', '[员工名称]', '[服务应用名称]'];
export default {
    components: {
        Wechat,
        AsideNav,
        TagEditor,
    },
    data() {
        return {
            appDetail: {},
            loading: false,
            visible: true,
            EDITOR_TAGS,
            isSaving: false,
            message: '',
            showMessage: '',
            saveBtnDisabled: false,
            inputLength: 0,
            weworkLoginUrl: '',
        };
    },
    computed: {
        isExpertWorkbench() {
            return this.appDetail.group_id === 1;
        },
        isModify() {
            return this.message !== this.appDetail.msg;
        },
        layout() {
            return {
                primary: {
                    text: '保存',
                    kind: 'primary',
                    loading: this.isSaving,
                    disabled: this.saveBtnDisabled || !this.isModify,
                },
                cancel: {
                    text: '取消',
                    disabled: !this.isModify,
                },
            };
        },
    },
    mounted() {
        this.visible = true;
        this.fetchAppDetail();
        getWeorkLoginPage().then((url) => {
            this.weworkLoginUrl = url;
        });
    },
    methods: {
        handleReset() {
            this.$refs.tagEditor.initData(this.appDetail.msg || '');
        },
        handleSave() {
            if (this.message.length === 0 || this.inputLength > 80) {
                return;
            }
            this.isSaving = true;
            this.$ajax
                .crossPost(`${envDomain.gateway}/v1/wework/staff/setCustomMsg`, {
                    app_id: getAppId(),
                    msg: this.message,
                })
                .then((res) => {
                    this.isSaving = false;
                    const { code } = res;
                    if (code === 0) {
                        this.$message.success('保存成功');
                        this.appDetail.msg = this.message;
                    } else {
                        this.$message.error(res.message || '网路错误');
                    }
                })
                .catch((err) => {
                    this.isSaving = false;
                    throw err;
                });
        },
        transformRichText2ShowText(text = '') {
            return text
                .replaceAll('[组织架构]', '设计部')
                .replaceAll('[员工名称]', '小明')
                .replaceAll('[服务应用名称]', 'HR服务助手');
        },
        handleInputChange({ html, inputLength }) {
            this.message = html;
            this.showMessage = this.transformRichText2ShowText(html);
            this.saveBtnDisabled = html.length === 0;
            this.inputLength = inputLength;
        },
        fetchAppDetail() {
            this.loading = true;
            this.$ajax
                .gatewayGet('/v1/wework/staff/staffAppDetail', {
                    params: {
                        app_id: getAppId(),
                    },
                })
                .then((res) => {
                    this.loading = false;
                    const { code } = res;
                    if (code === 0) {
                        this.appDetail = res.data;
                        this.message = res.data.msg || '';
                    } else if (code === ERR_APP_ID_CODE) {
                        window.location.href = ERR_APP_ID_CODE_JUMP_URL;
                    } else {
                        this.$message.error(res.message || '网路错误');
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    throw err;
                });
        },
    },
};
</script>
<style lang="less">
@import './styles/app.less';
</style>
